import { EntityNode } from "./EntityNode";
import { GameObjectManager } from "../GameObjectManager";
import { ActionStateEnum } from "../../state/actionState/ActionState";
import { EntityManager } from "../EntityManager";
import { Plan2DConstantes } from "../PlanManager";
import { PlanManager } from "../../../../cocosPlan";
import { IdleDecoration } from "../../state";
import { ComponentConstants, Events, eventsManager, Joinery, JoineryType, math, SavaneMath, SceneConstants } from "@rhinov/savane-js";
import { getMediaUrl } from "@rhinov/asset-manager-service";

declare var cc: any;

export class JoineryNode extends EntityNode {

    //@private
    _joineryType: number = 0;
    //@const
    _VALID_OVERLAP_COLOR = new cc.Color(176, 190, 197, 255);
    //@const
    _OVERLAP_COMPONENT = new cc.Color(120, 120, 120, 255);
    //@const
    _NOT_VALID_OVERLAP_COLOR = new cc.Color(255, 125, 141, 255);
    declare savaneEntity: Joinery;

    static ImageSizeExtentions: number[] = [
        32,
        64,
        128,
        256,
        512,
    ];

    constructor(joinery: Joinery) {
        super(joinery);
        this.savaneEntity = joinery
        this._joineryType = joinery.joineryType;
        //this.virtual = false;
        this.setCascadeColorEnabled(true);
        this._scalable = joinery.scalable;

        // Don't show detailed height
        this.showDetailedHeight = false;

        this.needRedraw = true;

        // Do we have to draw with transparency ?
        this.transparentDraw = PlanManager.getInstance()._wallWireframe;

        if (this.savaneEntity.joineryType !== SceneConstants.JoineryType.velux) {
            this.joineryLabel = new cc.LabelTTF(this.getJoineryLabel(), 'Roboto-Light', 12, new cc.size(0, 20), cc.TEXT_ALIGNMENT_CENTER, cc.TEXT_ALIGNMENT_CENTER);
            this.joineryLabel.setName('JoineryLabel');
            this.joineryLabel.setFontFillColor(new cc.color(150, 150, 150, 255));
            this.joineryLabel.setAnchorPoint(new cc.p(0.5, 0.5));
            this.joineryLabel.zIndex = 999999;
            this.joineryLabel.setVisible(true);
        }

        var component = joinery.getComponent(ComponentConstants.ComponentType.JoineryType) as JoineryType;

        if (component !== null) {
            var joineryAssetId = component.joineryTypeId;
            var url = getMediaUrl() +
                'joineries/' +
                joineryAssetId +
                '/medias/previews/preview1-sm.webp';

            this._spritePreview = new cc.Sprite(url);
            this._spritePreview.setAnchorPoint(new cc.p(0.5, 0.5));
            this._spritePreview.zIndex = 999999;
            this._spritePreview.setVisible(true);
        }

        this.update(undefined);

        // Listener for background image addition (post to the room node creation)
        this.detailedHeightListener = eventsManager.instance.addListener(Events.SHOW_DETAILED_HEIGHT, (_event: any) => {
            if (this.showDetailedHeight !== _event.userData) {
                this.showDetailedHeight = _event.userData;
                this.needRedraw = true;
                this.update();
            }
        });

        this.setJoineryTransparency = eventsManager.instance.addListener(Events.WALL_SET_TRANSPARENCY, (_event: any) => {
            this.needRedraw = true;
            this.transparentDraw = PlanManager.getInstance()._wallWireframe;
        });
    }

    getJoineryLabel(): string {
        var str = 'Allège ';

        if (this.savaneEntity.bottomTransom) {
            str += Math.floor(this.savaneEntity.bottomTransomHeight / 10);
        }
        else {
            str += Math.floor(this.savaneEntity.floorHeight / 10);
        }

        str += 'cm - Hauteur ';

        if (this.savaneEntity.transom) {
            str += Math.floor(this.savaneEntity.transomHeight / 10);
        }
        else {
            str += Math.floor((this.savaneEntity.floorHeight + this.savaneEntity.height) / 10);
        }

        str += 'cm';

        return (str);
    }

    computeModel(_joinery: Joinery) {
    }

    drawOverlap(_joinery: Joinery, _isValid: boolean) {

    }

    /*
     Getters & Setters
     */
    setJoineryType(joineryType: number) {
        this._joineryType = joineryType;
    }

    getJoineryType(): number {
        return this._joineryType;
    }

    getOverLapColor(isValid: boolean): {border: any, plain: any} {
        var colorItem = null;
        if (isValid) {
            if (this._isSelected) {
                colorItem = {
                    plain: new cc.color('#fbe800'),
                    border: new cc.color('#fbe800')
                };
            } else {
                if (this._isHovered) {
                    colorItem = {
                        plain: new cc.color(185, 185, 185),
                        border: new cc.Color(66, 80, 94, 255)
                    };
                } else {
                    colorItem = {
                        plain: new cc.color(255, 255, 255),
                        border: new cc.Color(66, 80, 94, 255)
                    };
                }
            }
        } else {
            colorItem = {
                plain: this._NOT_VALID_OVERLAP_COLOR,
                border: this._NOT_VALID_OVERLAP_COLOR
            };
        }
        if (PlanManager.getInstance().highlightMode) {
            colorItem.plain.a = 75;
        }
        if (this.transparentDraw) {
            colorItem.plain.a = 64;
        }

        return colorItem;
    }

    /**
    * Select node and children
    **/
    setSelected(value: boolean) {
        if (this._isSelected !== value) {
            this.needRedraw = true;
        }

        super.setSelected(value);
    }

    /**
    * Hover node
    **/
    setHovered(value: boolean) {
        if (this._isHovered !== value) {
            this.needRedraw = true;
        }

        super.setHovered(value);
    }

    computeAngle(comp?: number) {
        var angle = 0;

        if (this.savaneEntity.wall !== null) {
            angle = Math.atan2(this.savaneEntity.wall.wallDirection[0], this.savaneEntity.wall.wallDirection[1]);
            if (!this.savaneEntity.orientation) {
                angle += Math.PI;
            }
        }
        angle = (angle - Math.PI * 0.5) * 180 / Math.PI;
        this.setRotation(angle - (comp ? comp : 0));
    }
    removeAllChildren() {
        var i = 0;
        var children = this.getChildren();
        while (children.length !== i) {
            if (children[i].getName() === undefined ||
                children[i].getName() === null ||
                typeof children[i].getName() !== "string" ||
                children[i].getName().search('JoineryChildNode') === -1) {
                this.removeChild(children[i]);
            } else {
                i++;
            }
        }
    }

    update(dt?: any) {
        if (this.needRedraw || this._isSelected || this._isHovered || !this.savaneEntity.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!)) {
            var planManager = PlanManager.getInstance();

            super.update(dt, false);

            if (!this.savaneEntity.orientation) {
                this.setRotation((-this.savaneEntity.transform.localZRotation * 180 / Math.PI) + 180);
            }

            if (this.savaneEntity.parent === null) {
                this.computeAngle(-this.savaneEntity.transform.globalZRotation * 180 / Math.PI);
            } else {
                this.computeAngle(undefined);
            }

            this.updateModel(this.savaneEntity, this.savaneEntity.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!));
            if (this._isSelected) {
                if (this._scalable) {
                    var beginLength = math.vec3.create();
                    var endLength = math.vec3.create();

                    var beginWidth = math.vec3.create();
                    var endWidth = math.vec3.create();

                    if (this.savaneEntity.wall != null) {
                        SavaneMath.computeJoineryExtremities(this.savaneEntity.wall, this.savaneEntity, beginLength, endLength, beginWidth, endWidth);

                        var dbl = math.vec3.create();
                        dbl[0] = beginLength[0] - this.savaneEntity.position[0];
                        dbl[1] = beginLength[1] - this.savaneEntity.position[1];
                        math.vec3.normalize(dbl, dbl);

                        var del = math.vec3.create();
                        del[0] = endLength[0] - this.savaneEntity.position[0];
                        del[1] = endLength[1] - this.savaneEntity.position[1];
                        math.vec3.normalize(del, del);

                        var dbw = math.vec3.create();
                        dbw[0] = beginWidth[0] - this.savaneEntity.position[0];
                        dbw[1] = beginWidth[1] - this.savaneEntity.position[1];
                        math.vec3.normalize(dbw, dbw);

                        var dew = math.vec3.create();
                        dew[0] = endWidth[0] - this.savaneEntity.position[0];
                        dew[1] = endWidth[1] - this.savaneEntity.position[1];
                        math.vec3.normalize(dew, dew);

                        this.createdJoineryExtrems = true;
                        // In decoration state, always hide rotation and resize nodes
                        if ((planManager._state as unknown as IdleDecoration).state !== ActionStateEnum.idleDecoration) {
                            GameObjectManager.createJoineryExtremity(this.savaneEntity, new cc.p(beginLength[0] / 10 - 5 * dbl[0], beginLength[1] / 10 - 5 * dbl[1]), this.savaneEntity.wall, 'SelectedJoineryPoint' + this.savaneEntity.id);
                            GameObjectManager.createJoineryExtremity(this.savaneEntity, new cc.p(endLength[0] / 10 - 5 * del[0], endLength[1] / 10 - 5 * del[1]), this.savaneEntity.wall, 'SelectedJoineryPoint2' + this.savaneEntity.id);
                            if (this.savaneEntity.joineryType === SceneConstants.JoineryType.velux) {
                                GameObjectManager.createJoineryExtremity(this.savaneEntity, new cc.p(beginWidth[0] / 10 - 5 * dbw[0], beginWidth[1] / 10 - 5 * dbw[1]), this.savaneEntity.wall, 'SelectedJoineryPoint3' + this.savaneEntity.id);
                                GameObjectManager.createJoineryExtremity(this.savaneEntity, new cc.p(endWidth[0] / 10 - 5 * dew[0], endWidth[1] / 10 - 5 * dew[1]), this.savaneEntity.wall, 'SelectedJoineryPoint4' + this.savaneEntity.id);
                            }
                        }
                        GameObjectManager.drawJoineryDimension(this.savaneEntity);
                    } else {
                        if (this.createdJoineryExtrems) {
                            this.createdJoineryExtrems = false;

                            // In decoration state, always hide rotation and resize nodes
                            if ((planManager._state as unknown as IdleDecoration).state !== ActionStateEnum.idleDecoration) {
                                GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint' + this.savaneEntity.id);
                                GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint2' + this.savaneEntity.id);
                                if (this.savaneEntity.joineryType === SceneConstants.JoineryType.velux) {
                                    GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint3' + this.savaneEntity.id);
                                    GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint4' + this.savaneEntity.id);
                                }
                            }
                            GameObjectManager.deleteJoineryDimension(this.savaneEntity.id);
                        }
                    }
                }
                else {
                    if (this.savaneEntity.wall != null) {
                        GameObjectManager.drawJoineryDimension(this.savaneEntity);
                    } else {
                        GameObjectManager.deleteJoineryDimension(this.savaneEntity.id);
                    }
                }
            } else {
                if (this.createdJoineryExtrems) {
                    this.createdJoineryExtrems = false;
                    GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint' + this.savaneEntity.id);
                    GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint2' + this.savaneEntity.id);
                    if (this.savaneEntity.joineryType === SceneConstants.JoineryType.velux) {
                        GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint3' + this.savaneEntity.id);
                        GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint4' + this.savaneEntity.id);
                    }
                    GameObjectManager.deleteJoineryDimension(this.savaneEntity.id);
                }
            }

            for (var i = 0; i < this.savaneEntity.children.length; i++) {
                var node = EntityManager.getInstance().getNode(this.savaneEntity.children[i]);

                if (node !== null) {
                    node.needRedraw = true
                }
            }

            if (this.showDetailedHeight) {
                var posY = 0;

                if (this.joineryLabel) {
                    var thickness = 0;

                    if (this.savaneEntity.wall !== null) {
                        if (this.savaneEntity.wall.thickness > 150) {
                            thickness = this.savaneEntity.wall.thickness;
                        }
                        else {
                            thickness = 150;
                        }
                    }
                    var posY = (((thickness / 10) + 16) / 2);
                    this.joineryLabel.setString(this.getJoineryLabel());
                    this.joineryLabel.setPosition(new cc.p(0, posY));
                    this.joineryLabel.setScale(1.0 / PlanManager.getInstance().getZoomScale());
                    this.addChild(this.joineryLabel);
                }

                if (this._spritePreview) {
                    if (this.savaneEntity.joineryType !== SceneConstants.JoineryType.velux) {
                        posY += ((this._spritePreview.height + 32) / 2) / (PlanManager.getInstance().getZoomScale() * 2.5);
                    }
                    this._spritePreview.setPosition(new cc.p(0, posY));
                    this._spritePreview.setScale(1.0 / (PlanManager.getInstance().getZoomScale() * 2.5));
                    this.addChild(this._spritePreview);
                }
            }

            this.needRedraw = false;
        }
    }

    updateChildren(isValid: boolean) {
        var children = this.getChildren();
        for (var i = 0; i < children.length; i++) {
            if (children[i].getName() !== undefined &&
                children[i].getName() !== null &&
                typeof children[i].getName() === "string" &&
                children[i].getName().search('JoineryChildNode') !== -1) {
                children[i].update(isValid);
            }
        }
    }
    updateModel(joinery: Joinery, isValid: boolean) {
        this.updateChildren(isValid);
        /*var position = GameObjectManager.convertToCocosCoord(joinery.position);
        this.setPosition(position);*/
        this.setColor(isValid ? Plan2DConstantes.joineryvec4Valid : Plan2DConstantes.joineryvec4Valid);
        //this.computeAngle(joinery);
        this._scalable = joinery.scalable;
    }
    removeListeners() {
        eventsManager.instance.removeListener(this.detailedHeightListener);
        eventsManager.instance.removeListener(this.highlightListener);
        eventsManager.instance.removeListener(this.zoomListener);
        eventsManager.instance.removeListener(this.setJoineryTransparency);
    }
    onEnter() {
        super.onEnter();
        this.zoomListener = eventsManager.instance.addListener(Events.ZOOM_SCROLLWIN_CHANGED, (_event: any) => {
            this.removeAllChildren();
            this.computeModel(this.savaneEntity);
            this.drawOverlap(this.savaneEntity, this.savaneEntity.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!));
        });

        this.highlightListener = eventsManager.instance.addListener(Events.TOGGLE_HIGHLIGHT_MODE, (_event: any) => {
            this.removeAllChildren();
            this.computeModel(this.savaneEntity);
            this.drawOverlap(this.savaneEntity, this.savaneEntity.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!));
        });
    }
    onExit() {
        super.onExit();
        GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint' + this.savaneEntity.id);
        GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint2' + this.savaneEntity.id);
        if (this.savaneEntity.joineryType === SceneConstants.JoineryType.velux) {
            GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint3' + this.savaneEntity.id);
            GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint4' + this.savaneEntity.id);
        }
        GameObjectManager.deleteJoineryDimension(this.savaneEntity.id);
        this.removeListeners();
    }
}


